import React from 'react'

import { ZariContext } from '_zari/context'

import { TreeView, Portlet, Row, Col, Button } from '_zari/core'

import { ZrSwal } from 'utils'

import * as PresupuestoService from 'services/presupuesto.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Presupuestos' }]

const MainPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [listaPresupuestos, setListaPresupuestos] = React.useState([])
  const [mostrarNuevoModal, setMostrarNuevoModal] = React.useState(false)

  const selectedNodeIdRef = React.useRef('')

  const nuevoModalDataRef = React.useRef({})

  const refreshTreeView = React.useCallback(() => {
    PresupuestoService.obtenerAsTreeView().then(({ data }) => {
      setListaPresupuestos(data)
    })
  }, [])

  React.useEffect(() => {
    refreshTreeView()
  }, [refreshTreeView])

  const clickAgregarPresupuesto = React.useCallback(() => {
    if (selectedNodeIdRef.current) {
      let salida = {}
      const matchNodo = listaPresupuestos.find(x => x._id === selectedNodeIdRef.current)

      if (matchNodo) {
        if (matchNodo.nivel === 3) {
          __zariContext.snack('warning', 'No se puede asignar nodos a nivel 3.')
          return
        }

        if (matchNodo.nivel === 2) {
          salida.datoPresupuestoNivel2 = matchNodo.codigoCalculado
          salida.nivelBloqueo = 2

          const matchNivel1 = listaPresupuestos.find(x => x._id === matchNodo._parentId)
          salida.datoPresupuestoNivel1 = matchNivel1.codigoCalculado
        }

        if (matchNodo.nivel === 1) {
          salida.datoPresupuestoNivel1 = matchNodo.codigoCalculado
          salida.nivelBloqueo = 1
        }
      }

      nuevoModalDataRef.current = salida
    } else {
      nuevoModalDataRef.current = {}
    }

    setMostrarNuevoModal(true)
  }, [__zariContext, listaPresupuestos])

  const clickEliminar = React.useCallback(() => {
    ZrSwal.showAlert({
      mensaje: 'Seguro que desea eliminar el registro?',
      tipo: 'error',
      onSuccess: () => {
        PresupuestoService.eliminarxId(selectedNodeIdRef.current)
          .then(() => {
            __zariContext.snack('success', 'El registro se ha eliminado.')
            refreshTreeView()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      },
      showCerrar: true
    })
  }, [__zariContext, refreshTreeView])

  const onSelectNode = React.useCallback(nodeId => {
    selectedNodeIdRef.current = nodeId
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Presupuestos' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row className='mb-2'>
            <Col md={12} className='text-right'>
              <Button outline tiny onClick={clickAgregarPresupuesto}>
                Agregar
              </Button>
              <Button color='danger' outline tiny onClick={clickEliminar}>
                Eliminar
              </Button>
            </Col>
          </Row>
          <div className='treeview_wrapper'>
            <TreeView items={listaPresupuestos} onSelect={onSelectNode} />
          </div>
        </Portlet.Body>
      </Portlet>
      {mostrarNuevoModal && (
        <Modals.NuevoModal
          handleClose={e => setMostrarNuevoModal(false)}
          show={mostrarNuevoModal}
          refreshTreeView={refreshTreeView}
          modalData={nuevoModalDataRef.current}
        />
      )}
    </>
  )
}

export default React.memo(MainPage)
